import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import styled from 'styled-components';

import GetUpdatesCheckbox from '../Widget/GetUpdatesCheckbox';

import ReactGoogleAutocomplete from '../InputFields/GoogleMapsAddressField';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';
import { LoadingSpinner } from '../../components/LoadingSpinner';

import {
    ButtonGroupWrapper,
    Container,
    GroupLabel,
    MultipleGroupFirstMed,
    MultipleGroupFull,
    MultipleGroupLast
} from '../../containers/DefaultStyles/FormDetails';

import { getCachedFirstName, getCachedLastName } from '../../utils/formCaching/helpers';
import {
    DayDropdownValues,
    MonthDropdownValues,
    YearDropdownValues,
    StatesId
} from '../../utils/enums';
import validate from './validations';
import { isPortrait } from '../../utils/size';

const CheckboxWrapper = styled.div`
    display: flex;
    padding: 2.5px 0;
    @media (min-width: 30em) {
        flex-direction: column;
        position: absolute;
        left: -50%;
        top: 78%;
        padding: 5px 0;
    }
`;
const RemindersNotice = styled.div`
    font-size: 12px;
    font-family: Averta;
    padding-bottom: 5px;

    @media (min-width: 30em) {
        max-width: 160px;
        position: absolute;
        left: -50%;
        top: 68%;
    }
`;

class CheckRegistrationForm extends React.Component {
    constructor() {
        super();
        this.state = {
            valid: false
        };
    }

    setValidState(bool) {
        this.setState({ valid: bool });
    }

    render() {
        return (
            <Container
                noOverflow
                style={{ marginTop: `${isPortrait() ? `20px` : `0px`}` }}
                autocomplete="on"
                onSubmit={this.props.handleSubmit}
            >
                <MultipleGroupFull>
                    <Field
                        name="firstName"
                        component={InputGroup}
                        type="text"
                        label="First name"
                        placeholder="First Name"
                        autocomplete="off"
                    />
                    <Field
                        name="lastName"
                        component={InputGroup}
                        type="text"
                        label="Last name"
                        placeholder="Last Name"
                        autocomplete="off"
                    />
                </MultipleGroupFull>
                {!this.props.isMobileResolution && (
                    <MultipleGroupLast>
                        <ReactGoogleAutocomplete
                            formName={['checkRegistrationForm', 'google_autocomplete']}
                            fields={['address_components', 'formatted_address']}
                            types={['address']}
                            componentRestrictions={{ country: 'US' }}
                            setValidState={this.setValidState.bind(this)}
                            typeToReturn={'object'}
                        />
                    </MultipleGroupLast>
                )}
                {this.props.isMobileResolution && (
                    <MultipleGroupFull>
                        <ReactGoogleAutocomplete
                            formName={['checkRegistrationForm', 'google_autocomplete']}
                            fields={['address_components', 'formatted_address']}
                            types={['address']}
                            componentRestrictions={{ country: 'US' }}
                            setValidState={this.setValidState.bind(this)}
                            typeToReturn={'object'}
                        />
                    </MultipleGroupFull>
                )}
                <MultipleGroupFirstMed
                    style={{
                        position: 'relative',
                        paddingTop: '14px'
                    }}
                >
                    <GroupLabel
                        style={{
                            position: 'absolute',
                            left: `15px`,
                            top: '0px'
                        }}
                    >
                        {'Date of Birth'}
                    </GroupLabel>
                    <Field
                        name="month"
                        component={DropDownSelect}
                        options={this.props.month}
                        label="Month"
                        type="text"
                    />
                    <Field
                        name="day"
                        component={DropDownSelect}
                        options={this.props.day}
                        label="Day"
                        type="text"
                    />
                    <Field
                        name="year"
                        component={DropDownSelect}
                        options={this.props.year}
                        label="Year"
                        type="text"
                    />
                </MultipleGroupFirstMed>
                <MultipleGroupLast>
                    <Field
                        name="email"
                        component={InputGroup}
                        type="email"
                        label="Email"
                        placeholder="Email"
                        autocomplete="off"
                    />
                </MultipleGroupLast>
                <RemindersNotice>
                    {'Stay informed of key dates and events:'}
                </RemindersNotice>
                <CheckboxWrapper>
                    <GetUpdatesCheckbox
                        style={{
                            padding: `${isPortrait() ? `2px 0` : `12px 0`}`
                        }}
                        labelText="Receive Reminders"
                        defaultChecked={!this.props.endUserLocation.isEU}
                        isEU={this.props.endUserLocation.isEU}
                    />
                </CheckboxWrapper>
                <ButtonGroupWrapper
                    isFormSubmitting={this.props.isFormSubmitting}
                    rightPosition={23}
                >
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            className="submitButton"
                            disabled={this.props.invalid || !this.state.valid}
                            isSubmitting={this.props.isFormSubmitting}
                        />
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

CheckRegistrationForm.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    isFormSubmitting: PropTypes.bool,
    day: PropTypes.array.isRequired,
    month: PropTypes.array.isRequired,
    year: PropTypes.array.isRequired,
    isMobileResolution: PropTypes.bool.isRequired,
    endUserLocation: PropTypes.object.isRequired
};

export default compose(
    connect(state => ({
        initialValues: {
            getUpdates: !(state.widget.endUserLocation || {}).isEU,
            firstName: getCachedFirstName(state),
            lastName: getCachedLastName(state),
            address:
                state.cachedFormData.homeAddress || state.cachedFormData.address || '',
            stateId: state.cachedFormData.stateId || '',
            month: state.cachedFormData.month || '',
            day: state.cachedFormData.day || '',
            year: state.cachedFormData.year || '',
            email: state.cachedFormData.email || ''
        },
        day: DayDropdownValues(),
        month: MonthDropdownValues,
        year: YearDropdownValues(),
        states: StatesId,
        isMobileResolution: state.widget.isMobileResolution,
        endUserLocation: state.widget.endUserLocation || {}
    })),
    reduxForm({
        form: 'checkRegistrationForm',
        destroyOnUnmount: false,
        validate
    })
)(CheckRegistrationForm);
